import styles from "./Topbanner.module.scss";
import Link from 'next/link';
import Image from "next/image";
import { gsap } from "gsap/dist/gsap";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";

if (process.client) {
    gsap.registerPlugin(ScrollToPlugin);
}

function HomeBanner(props) {
    const handleClick = (e) => {
        gsap.registerPlugin(ScrollToPlugin);
        e.stopPropagation()
        gsap.to(window, {
            duration: 1,
            scrollTo: {
                y: `${props.target}`,
                offsetY: 70,
            }
        })
    }
    return (
        <>
            <section
                className={styles.home_banner}
                style={{ backgroundImage: `url(${props.bgImage})` }}
            >
                <div className={styles.banner_text}>
                    <div className="container">
                        <div className={`${styles.banner_text_con} common_title`}>
                            <h1 className='animate_title'>{props?.title}</h1>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default HomeBanner;